export default __webpack_public_path__ + "static/media/four-icon.af929c53.svg";